/** @jsx h **/
import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  inject,
  h,
  Fragment,
} from "vue";

import { IModeTypes } from "@gratico/banyan";
import { Loading } from "@gratico/uikit";
import { CheckoutTree as CheckoutTreeLayout } from "./CheckoutTree";
export { IModeTypes } from "@gratico/banyan";
import { ShellProps, ShellPropsList } from "@gratico/sdk";

const modesData: { [key: string]: { icon: string } } = {
  simple: { icon: "ri-node-tree" },
  file: { icon: "ri-code-line" },
  layers: { icon: "ri-stack-fill" },
};

export const CheckoutTree = defineComponent<ShellProps>({
  name: "CheckoutTree",
  props: [...ShellPropsList],
  setup(props, ctx) {
    // return null;
    // const { sidebarRef, $expanded, mouseEvent } = useSliding(undefined, -1);
    const { master, kernel, refName } = props;
    const $loaded = ref(false);
    onMounted(async () => {
      const checkouts = await master.getCheckouts();
      console.log("checkouts", checkouts, props);
      checkouts.find((el) => el.id === refName) ||
        (await (async function () {
          await master.getOrCreateCheckout(props.session.project.id, {
            refName,
          });
          //console.log("created checkout");
          $loaded.value = true;
        })());
    });
    return () => (
      <Fragment>
        {$loaded.value ? (
          <div class={"w-full h-full relative text-1xl p-2"}></div>
        ) : (
          <div>...</div>
        )}
      </Fragment>
    );
  },
});
